import React from 'react';
import ReactDOM from 'react-dom';
import './Styles/index.sass';

import { App } from './App';

ReactDOM.render(<App />, document.getElementById('root'));
